// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2bHkL","bigColWidth":"Table_bigColWidth__18__c","biggerColWidth":"Table_biggerColWidth__AvcIj","row":"Table_row__13h-i","col":"Table_col__2PrOt"};